export default "__VITE_ASSET__8fZwMM24__"